import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=3fdb43a9&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"
import style0 from "./Summary.vue?vue&type=style&index=0&id=3fdb43a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb43a9",
  null
  
)

export default component.exports